import React, { useMemo, useState, useEffect, useCallback, useReducer } from 'react';

import {
	LocallySortedAndPaginatedTable,
	Dialog, Card
} from '@bosch/bt-ui';
import './ContentDialog.css';
import withErrorHandler from './ErrorHandler';

const ContentDialog = (props) => {
	const {
		openDialog,
		setOpenDialog,
		tableHeaders,
		tableRows,
		numRowsPerPage
	} = props;


	const [currentPage, setCurrentPage] = useState(1);
	const onCloseModal = () => setOpenDialog(false);

	return (
		<Dialog onClose={onCloseModal}
			dialogOptions={{
				open: openDialog
			}}
		>
			<Card
				htmlAttributes={{
					id: 'wc-metrics-detail-page'
				}}
			>
				<LocallySortedAndPaginatedTable
					headers={tableHeaders}
					rows={tableRows}
					numRowsPerPage={numRowsPerPage}
					currentPage={currentPage}
					goToPageFunc={setCurrentPage}
					htmlAttributes={{
						className: 'wc-metrics-detail-table'
					}}
					errorMessage="Error occured"
					noResultsMessage=""
				/>
			</Card>
		</Dialog>
	);
}

export default withErrorHandler(ContentDialog);